import React from 'react';
import { SideNavGroup } from '@amzn/aac-chrome-internal-api';
import {
  ExpandedListWrapper,
  ExpandedListGroupTitle,
  ExpandedListItem,
  SideGroupMobileDivider,
} from './styles';
import { renderTag } from './MobileSideNavItem';

interface MobileSideNavExpandedListProps {
  sidebarGroups: Array<SideNavGroup>;
  sidebarGroupTitle?: string;
}

const ExpandedMenuItemList: React.VFC<MobileSideNavExpandedListProps> = ({
  sidebarGroups,
  sidebarGroupTitle,
}) => {
  const items = sidebarGroups.map((group, groupIndex) => (
    <React.Fragment key={groupIndex}>
      {groupIndex > 0 && <SideGroupMobileDivider role="separator" />}
      {group.title &&
        group.title.length > 0 &&
        group.title !== sidebarGroupTitle && (
          <ExpandedListGroupTitle>{group.title}</ExpandedListGroupTitle>
        )}
      {group.links.map((sideNavLinkProp) => (
        <ExpandedListItem
          key={sideNavLinkProp.id}
          href={sideNavLinkProp.link.url}
          data-takt-id={sideNavLinkProp.id}
          isSelected={sideNavLinkProp.isSelected}
        >
          {sideNavLinkProp.link.label}
          {renderTag(sideNavLinkProp)}
        </ExpandedListItem>
      ))}
    </React.Fragment>
  ));
  return <ExpandedListWrapper>{items}</ExpandedListWrapper>;
};

export default ExpandedMenuItemList;
